export const DEPRECATED_PROMO_TOKENS = [
  "7b8d1a4c-9e5f-4d3b-a2c1-f6e9d8a7b5c3",
  "a3c7e1f9-2b4d-4a8e-9c5f-1d6e8b0a4f2c",
];

export const PROMO_CONFIG = {
  gac15: {
    percent: 15,
    factor: 0.85,
  },
  gac20: {
    percent: 20,
    factor: 0.8,
  },
};

export const getPaymentAccessToken = (location) => {
  const searchParams = new URLSearchParams(location.search);
  const hashToken =
    typeof window !== "undefined"
      ? window.location.hash.replace(/^#/, "")
      : "";
  return hashToken || searchParams.get("promo") || searchParams.get("d");
};

export const isDeprecatedPromoAccess = (location) =>
  DEPRECATED_PROMO_TOKENS.includes(getPaymentAccessToken(location));

export const getPromoConfig = (location) => {
  const token = getPaymentAccessToken(location);
  return PROMO_CONFIG[token] || null;
};

export const isPromoPaymentAccess = (location) =>
  Boolean(getPromoConfig(location));

export const PAYMENT_CONFIG = {
  MERCADO_PAGO: {
    PUBLIC_KEY: process.env.REACT_APP_API_KEY_MERCADOPAGO,
    LOCALE: "es-CO",
    CONTAINER_CLASS: "cho-container",
    ERROR_MESSAGES: {
      INIT_ERROR: "Error al inicializar MercadoPago",
      PREFERENCE_ERROR: "Error al crear la preferencia de pago",
      PROCESS_ERROR: "Error al procesar el pago",
      CONTAINER_ERROR: "Error al encontrar el contenedor de pago",
    },
  },
  PAYU: {
    ERROR_MESSAGES: {
      PROCESS_ERROR: "Error al procesar el pago con PayU",
    },
  },
  OPENPAY: {
    ERROR_MESSAGES: {
      PROCESS_ERROR: "Error al procesar el pago con Openpay",
    },
  },
};
